export enum DashboardAdminActionTypes {
  Init = '[DashboardAdmin Page] Initialise Admin Dashboard',

  LoadRecentlyViewedPolicies = '[DashboardAdmin Page] Load Recently Viewed Policies',
  LoadRecentlyViewedPoliciesSuccess = '[DashboardAdmin/API] Load Recently Viewed Policies Success',
  LoadRecentlyViewedPoliciesFailure = '[DashboardAdmin/API] Load Recently Viewed Policies Failure',
}

export enum DashboardBrokerNorwayActionTypes {
  Init = '[DashboardBrokerNorway Page] Initialise Broker Dashboard',
  TabIndexChanged = '[DashboardBrokerNorway Page] Tab Index Changed',
  EnquiriesFilterChanged = '[DashboardBrokerNorway Page] Enquiries Filter Changed',
  CancellationsFilterChanged = '[DashboardBrokerNorway Page] Cancellations Filter Changed',
}

export enum DashboardBrokerLsosActionTypes {
  Init = '[DashboardBrokerLsos Page] Initialise Broker Dashboard',

  TabIndexChanged = '[DashboardBrokerLsos/Page] Tab Index Changed',
  PoliciesFilterChanged = '[DashboardBrokerLsos Page] Policies Filter Changed',
  QuotesFilterChanged = '[DashboardBrokerLsos Page] Quotes Filter Changed',

  LeadBrokerAssignedToQuote = '[DashboardBrokerLsos Page] Lead Broker Assigned To Quote',
}
